<div class="dialog-header" insDraggable>
  <div class="dialogTitle">Search</div>
  <mat-icon class="dialogCloseIcon" svgIcon="dialog.close" (click)="close()"></mat-icon>
</div>
<div class="dialog-content" style="padding-bottom: 16px">
  <div class="searchCont">
    <ins-input-box [label]="'Search for placemark in the panoramic image'" [(value)]="filterStr" (valueChange)="filterResults()"
      [normalFontStyle]="true" [placeholder]="'placemark name'">
    </ins-input-box>
    <mat-icon class="searchIcon padRight8" svgIcon="sites.search"></mat-icon>
  </div>
  <div class="searchResults">
    @if (filteredPlacemarks.length === 0) {
      <div class="resultsLabel noContentAvailable">No result found</div>
    }
    @if (filteredPlacemarks.length > 0) {
      <div class="resultsLabel">Results</div>
    }
    <div class="resultsList">
      @for (pm of filteredPlacemarks; track pm) {
        <div class="resultEntry" (click)="onPmClicked(pm)">
          <img [src]="pm.icon | safe" width="16px" height="16px" alt="placemark icon">
          <div style="padding-left: 8px;">{{pm.name}}</div>
        </div>
      }
    </div>
  </div>

</div>
